import React, { useMemo } from 'react';
import OverlayMessage, { OverlayCoverDiv, OverlayMessageIcon } from './OverlayComponents';
import { AsoScenarioStatus } from '@ydistri/api-sdk';
import { useAsoScenarioStatus } from '../../../screens/Aso/hooks/useAsoScenarioStatus';

/**
 * Overlay that is displayed when the selected ASO scenario is queued or running.
 * Must be placed inside div with "position: relative"
 */
const AsoScenarioStatusOverlay: React.FC = () => {
  const { isLocked, message, status } = useAsoScenarioStatus();

  const icon: OverlayMessageIcon | undefined = useMemo(() => {
    switch (status) {
      case undefined:
        return undefined;
      case AsoScenarioStatus.Pending:
      case AsoScenarioStatus.Queued:
        return OverlayMessageIcon.PENDING;
      case AsoScenarioStatus.Running:
        return OverlayMessageIcon.RUNNING;
      case AsoScenarioStatus.Completed:
      case AsoScenarioStatus.Crashed:
      case AsoScenarioStatus.Outdated:
      default:
        return undefined;
    }
  }, [status]);

  if (!isLocked || !status) {
    return null;
  }

  return (
    <OverlayCoverDiv $contentPosition="top">
      <OverlayMessage icon={icon} title={status} content={message} />
    </OverlayCoverDiv>
  );
};

export default AsoScenarioStatusOverlay;
